import React, { useContext, useState, useEffect } from 'react';
import { Row, message, Form } from 'antd';
import moment from 'moment';
import EditForm from '../../../../components/EditForm';
import {
  ButtonCancelar,
  ButtonSalvar,
  DivButtons,
  DivItems,
} from '../../../../components/EditForm/styles';
import { EditorContext } from '../../EditorContext/editorContext';
import { getEstadosList } from '../../../../services/estado';
import { foneMask } from '../../../../helpers/helpersEditForm';
import {
  getEnderecoForm,
  enviarDadosPessoa,
  getPayloadPFPJ,
} from '../Helpers/helpers';

export default function InfoArrendatarioEdicao({
  dadosArrend,
  carregarSolicitacaoAtual,
  setSpinning,
  setReadOnly,
}) {
  const [listUF, setListUF] = useState([]);
  const [form] = Form.useForm();
  const { setLockButton } = useContext(EditorContext);

  const initialState = async () => {
    try {
      const response = await getEstadosList();
      setListUF(response.items);
    } catch (error) { }
  };

  useEffect(() => {
    initialState();
  }, []);

  const salvarEdicao = async form => {
    setLockButton(false);
    setReadOnly(true);

    const payload = getPayloadPFPJ(dadosArrend, form);

    return enviarDadosPessoa(
      setSpinning,
      carregarSolicitacaoAtual,
      setReadOnly,
      payload
    );
  };

  const handleCancel = () => {
    setReadOnly(true);
    setLockButton(false);
  };

  let arrendatarioPF = [
    {
      nome: 'nome',
      label: 'Nome',
      width: '32%',
      initialValue: dadosArrend?.pessoaFisicaCadastro?.nome || null,
    },
    {
      nome: 'cpf',
      label: 'CPF',
      width: '32%',
      initialValue: dadosArrend?.pessoaFisicaCadastro?.cpfFormatado || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      nome: 'nascimento',
      label: 'Data de Nascimento',
      width: '32%',
      initialValue:
        moment(dadosArrend?.pessoaFisicaCadastro?.dataNascimento).format(
          'DD/MM/YYYY'
        ) || null,
    },
    {
      nome: 'telefone',
      label: 'Telefone',
      width: '32%',
      initialValue: dadosArrend?.telefone || null,
      onChange: e => foneMask(e.target.value, form, 'telefone'),
    },
    {
      nome: 'nomeMae',
      label: 'Nome da mãe',
      width: '32%',
      initialValue: dadosArrend?.pessoaFisicaCadastro?.nomeMae || null,
    },
    {
      nome: 'nomePai',
      label: 'Nome do pai',
      width: '32%',
      initialValue: dadosArrend?.pessoaFisicaCadastro?.nomePai || null,
    },
    {
      nome: 'numeroPIS',
      label: 'Numero do PIS',
      width: '32%',
      initialValue: dadosArrend?.pessoaFisicaCadastro?.numeroPIS || null,
    },
    {
      nome: 'numeroRG',
      label: 'Numero do RG',
      width: '32%',
      initialValue: dadosArrend?.pessoaFisicaCadastro?.numeroRG || null,
    },
    {
      nome: 'ufrg',
      label: 'UF RG',
      width: '32%',
      initialValue: dadosArrend?.pessoaFisicaCadastro?.ufrg || null,
    },
  ];

  arrendatarioPF = getEnderecoForm(
    arrendatarioPF,
    dadosArrend?.dadosEndereco,
    listUF
  );

  let arrendatarioPJ = [
    {
      nome: 'nomeFantasia',
      label: 'Nome Fantasia',
      width: '98.7%',
      initialValue: dadosArrend?.pessoaJuridicaCadastro?.nomeFantasia || null,
    },
    {
      nome: 'razaoSocial',
      label: 'Razão social',
      width: '98.7%',
      initialValue: dadosArrend?.pessoaJuridicaCadastro?.razaoSocial || null,
    },
    {
      nome: 'cnpj',
      label: 'CNPJ',
      width: '32%',
      initialValue: dadosArrend?.pessoaJuridicaCadastro?.cnpjFormatado || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      nome: 'inscEstadual',
      label: 'Inscrição estadual',
      width: '32%',
      initialValue:
        dadosArrend?.pessoaJuridicaCadastro?.inscricaoEstadual || null,
    },
    {
      nome: 'telefone',
      label: 'Contato',
      width: '32%',
      initialValue: dadosArrend?.telefone || null,
      onChange: e => foneMask(e.target.value, form, 'telefone'),
    },
  ];

  arrendatarioPJ = getEnderecoForm(
    arrendatarioPJ,
    dadosArrend?.dadosEndereco,
    listUF
  );

  return (
    <Row
      justify="space-between"
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        marginTop: 32,
      }}
    >
      <Form form={form} layout="vertical" onFinish={form => salvarEdicao(form)}>
        {dadosArrend?.pessoaFisicaCadastro?.cpf ? (
          <DivItems>
            {arrendatarioPF.map(item => (
              <EditForm key={item.nome} item={item} form={form} />
            ))}
          </DivItems>
        ) : (
          <DivItems>
            {arrendatarioPJ.map(item => (
              <EditForm key={item.nome} item={item} form={form} />
            ))}
          </DivItems>
        )}

        <DivButtons>
          <Form.Item>
            <ButtonCancelar onClick={() => handleCancel()}>
              Cancelar
            </ButtonCancelar>
          </Form.Item>
          <Form.Item>
            <ButtonSalvar>Salvar</ButtonSalvar>
          </Form.Item>
        </DivButtons>
      </Form>
    </Row>
  );
}
